<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-book"></i> Lessons</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
              <router-link v-bind:to="{name: 'add-lesson' }" class="button is-info is-pulled-right">Add new</router-link>
            </div>
            <div class="column">
                <lessons-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged" :total="total" v-bind:items="lessons" v-bind:actions="true"></lessons-table>
            </div>
        </div>
    </div>
</template>

<script>
import LessonRepo from '../../repos/LessonRepo'
import lodash from 'lodash'
import LessonsTable from "./Table";

export default {
  name: 'lessons-view',
  components: {LessonsTable},
  data() {
        return {
            repo: new LessonRepo(this.$auth),
            lessons: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
        }
  },
  created(){
    this.getLessons();
  },
  methods: {
    onSearch(q){
        this.page = 1;
        this.q = q;
        this.getLessons();
    },
    onOrderBy(orderBy){
        this.page = 1;
        this.orderBy = orderBy;
        this.getLessons();
    },
    onPageChanged(page){
        this.page = page;
        this.getLessons();
    },
    getLessons(){
      let data = {
        page: this.page,
        query: this.q,
        orderBy: this.orderBy,
        //school_id: this.school_id
      };
        this.repo.paginate(data).then(response => {
            this.lessons = response.data.data;
            this.total = response.data.meta.pagination.total_pages
        });
    },
  },
  watch: {

  }

}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/lessons/View.vue